import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import BodyComponent from '@eeacms/volto-group-block/components/manage/Blocks/Group/Body';

const View = (props) => {
  const { data } = props;
  const CustomTag = 'div';
  const customId = data?.title
    ?.toLowerCase()
    ?.replace(/[^a-zA-Z-\s]/gi, '')
    ?.trim()
    ?.replace(/\s+/gi, '-');
  return (
    <CustomTag id={customId}>
      <BodyComponent {...props} />
    </CustomTag>
  );
};

export default withBlockExtensions(View);
